// import ywk from '@clouderwork/ywk';
import moment from 'moment';
import React from 'react';

moment.locale('cn', {
  relativeTime: {
    hh: '%d小时前',
    dd: '%d天前'
  },
  weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
  weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
  weekdaysMin: '日_一_二_三_四_五_六'.split('_')
});

// 抽离成可配置的匹配列表
const matchList = {
  '&lt;': '<',
  '&gt;': '>',
  '&amp;': '&',
  '&#34;': '"',
  '&quot;': '"',
  '&#39;': "'"
};

export default {
  /**
   * 转换后端传回的日期串
   * @param {*} val 值
   * @param {*} type 格式
   * @param {*} isMillisecond 是否是毫秒
   */
  getDate(val: any, type: any, isMillisecond = true) {
    let time: any = new Date();
    if (val) {
      time = isMillisecond ? new Date(val * 1000) : new Date(val.toString().replace(/-/g, '/'));
    }
    let year = time.getFullYear();
    let cmonth = time.getMonth() + 1;
    let month = cmonth < 10 ? '0' + cmonth : cmonth;
    let date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
    let hour: number | string = time.getHours();
    hour = hour < 10 ? '0' + hour : hour;
    let minutes: number | string = time.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let seconds: number | string = time.getSeconds();
    seconds = seconds < 10 ? '0' + seconds : seconds;
    let result: string | number = '';
    let now, day, diff;
    switch (type) {
      case 'y.m': // 2016.11
        result = year + '.' + month;
        break;
      case 'ym': // 2016.11.23
        result = year + '.' + month + '.' + date;
        break;
      case 'md': // 11.23
        result = month + '.' + date;
        break;
      case 'hm': // 10:56
        result = hour + ':' + minutes;
        break;
      case 'mdhm': // 11-23 10:56
        result = month + '-' + date + ' ' + hour + ':' + minutes;
        break;
      case 'hms': // 10:56:09
        result = hour + ':' + minutes + ':' + seconds;
        break;
      case 'm': // 06
        result = minutes;
        break;
      case 'm-d': // 11-23
        result = month + '-' + date;
        break;
      case 'ymhs': // 2016.11.23 10:56
        result = year + '.' + month + '.' + date + ' ' + hour + ':' + minutes;
        break;
      case 'ymhss': // 2016.11.23 10:56:00
        result = year + '.' + month + '.' + date + ' ' + hour + ':' + minutes + ':' + seconds;
        break;
      case 'ymdhms': // 20161123105600
        result = year + '' + month + '' + date + '' + hour + '' + minutes + '' + seconds;
        break;
      case 'y-mhs': // 2016-11-23 10:56
        result = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes;
        break;
      case 'ymdhm': // 2016-11-23
        result = year + '-' + month + '-' + date;
        break;
      case 'mdyr': // 11月23日
        result = month + '月' + date + '日 ';
        break;
      case 'ymd': // 2013年11月23日
        result = year + '年' + month + '月' + date + '日 ';
        break;
      case 'year': // 2016
        result = year;
        break;
      case 'task':
        now = new Date().getTime();
        day = new Date().getDate();
        diff = now - time;
        result = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes;
        if (diff < 86400000) {
          result = time.getDate() - day === 0 ? '今天 ' + hour + ':' + minutes : '昨天 ' + hour + ':' + minutes;
        } else if (diff < 86400000 * 2) {
          result = day - time.getDate() === 1 ? '昨天 ' + hour + ':' + minutes : result;
        }
        break;
      case 'delivery':
        now = new Date().getTime();
        day = new Date().getDate();
        diff = now - time;
        // 当年
        if (year === new Date().getFullYear()) {
          // 当天
          if (diff < 86400000 && time.getDate() - day === 0) {
            result = hour + ':' + minutes + '分';
          } else {
            result = month + '月' + date + '日 ';
          }
        } else {
          // 非当年
          result = year + '年' + month + '月' + date + '日 ';
        }

        break;
      default:
        result = year + '-' + month;
    }
    return result;
  },
  /**
   * 获取时间
   * @param val
   */
  getStartEnd(val: string, num: number = 0) {
    const today = moment().format('YYYY-MM-DD');
    const yestoday = moment().subtract(1, 'days').format('YYYY-MM-DD');
    const dayOfWeek = moment().format('d');

    switch (val) {
      case 'today':
        return [today, today];
      case 'yestoday':
        return [yestoday, yestoday];
      case '7day':
        return [moment().subtract(7, 'days').format('YYYY-MM-DD'), yestoday];
      case '30day':
        return [moment().subtract(30, 'days').format('YYYY-MM-DD'), yestoday];
      case 'week':
        return [
          moment()
            .subtract(+dayOfWeek - 1, 'days')
            .format('YYYY-MM-DD'),
          moment()
            .add(7 - +dayOfWeek, 'days')
            .format('YYYY-MM-DD')
        ];
      case 'lastweek':
        return [
          moment()
            .subtract(+dayOfWeek - 1 + 7, 'days')
            .format('YYYY-MM-DD'),
          moment()
            .subtract(+dayOfWeek, 'days')
            .format('YYYY-MM-DD')
        ];
      case 'otherweek':
        const wstart = moment().subtract(+dayOfWeek - 1 + num * 7, 'days');
        const wend = moment().subtract(+dayOfWeek - 1 + num * 7 - 6, 'days');
        let str = wstart.format('YYYY年MM月DD日至');
        if (wstart.format('YYYY') !== wend.format('YYYY')) {
          str += wend.format('YYYY年MM月DD日');
        } else if (wstart.format('MM') !== wend.format('MM')) {
          str += wend.format('MM月DD日');
        } else {
          str += wend.format('DD日');
        }
        return [wstart.format('YYYY-MM-DD'), wend.format('YYYY-MM-DD'), str];
      case 'month':
        return [moment().format('YYYY-MM-01'), today];
      case 'lastmonth':
        const start = moment().subtract(1, 'month').format('YYYY-MM-01');
        return [start, moment(start).add(1, 'month').subtract(1, 'days').format('YYYY-MM-DD')];
      case 'customize':
      default:
        return ['', ''];
    }
  },
  /**
   * 根据日期字符串显示更新时间 5天前 2019.10.10 xx小时前
   * @param time 日期字符串 "2019-10-29 14:32:54"
   */
  getUpdate(time: string) {
    // 如果当前时间小于更新时间
    if (moment().isBefore(time)) return '';
    // 24小时内
    if (moment().add(-1, 'days').isBefore(time)) {
      return `${Math.floor(
        (moment().toDate().getTime() - moment(time).toDate().getTime()) / (60 * 60 * 1000)
      )}小时前发布`;
    }
    // 五天前
    if (moment().add(-5, 'days').isBefore(time)) {
      return `${Math.ceil(
        (moment().toDate().getTime() - moment(time).toDate().getTime()) / (24 * 60 * 60 * 1000)
      )}天前发布`;
    }

    return `${moment(time).format('YYYY年MM月DD日')}发布`;
  },
  /** 设置倒计时 */
  downTime(time, before?, type?) {
    const now = new Date().getTime();
    time = new Date(time.toString().replace(/-/gi, '/')).getTime();
    let oneDay = 24 * 1000 * 60 * 60;
    if (Math.abs(time - now) > oneDay) {
      let diffDay = Math.floor(Math.abs(time - now) / oneDay);
      if (before) {
        if (Math.abs(time - now) > oneDay * 5) {
          return this.getDate(time / 1000, type || 'ymd', true);
        } else {
          return `${diffDay}天前`;
        }
      }
      return '<b>' + diffDay + '</b>天';
    } else {
      var h, m;
      let leftTime = Math.abs(time - now);
      if (leftTime >= 0) {
        h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        m = Math.floor((leftTime / 1000 / 60) % 60);
      }
      if (before) {
        if (h <= 0) {
          if (m < 1) {
            return '刚刚';
          }
          return `${m}分钟前`;
        }
        return `${h}小时前`;
      }
      return `<b>${h}</b>小时<b>${m}</b>分`;
    }
  },
  decodeAtMsg(text, isNofity?) {
    if (!text) return '';
    let msg = text;
    // 解析 @ta
    msg = msg.replace(/&lt;/g, '<');
    msg = msg.replace(/&gt;/g, '>');
    if (isNofity) {
      msg = msg.replace(/<@([^|]+)\|([^>]+)>/g, '@$2');
    } else {
      msg = msg.replace(/\n/g, '{{br}}');
      msg = msg.replace(/\s/g, '&ensp;');
      msg = msg.replace(/<@([^|]+)\|([^>]+)>/g, '{{span data-uuid="$1" class="atta"}}@$2{{/span}} ');
    }
    msg = msg.replace(/{{/g, '<');
    msg = msg.replace(/}}/g, '>');
    return msg;
  },
  trimFilters(val) {
    let decode = this.decodeAtMsg(val, false);
    let urlReg = /((http|ftp|https):\/\/)+[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/g;
    let str;
    str = decode
      .trim()
      .replace(/(\n)/g, '<br>')
      .replace(urlReg, function (item) {
        let linkTxt = item.replace(/&ensp;/g, '');
        return `<a class="href-btn" href="${linkTxt}" target="_blank">${item}</a>`;
      });
    return str;
  },
  getFileTypeElemFormatter(fileUrl: string): React.ReactNode {
    const fileType = fileUrl.substring(fileUrl.lastIndexOf('.') + 1);

    let img;
    switch (fileType) {
      case 'mp3':
      case 'm4a':
      case 'wav':
      case 'aac':
      case 'amr':
      case 'flac':
        img = <img src={require('@src/assets/images/common/audio.png')} alt="音频" />;
        break;
      case 'mp4':
      case 'avi':
      case 'flv':
      case 'm4v':
      case 'mkv':
      case 'mov':
      case 'mpeg':
      case 'wmv':
        img = <img src={require('@src/assets/images/common/video.png')} alt="视频" />;
        break;
      case 'xls':
      case 'xlsx':
        img = <img src={require('@src/assets/images/common/excel.png')} alt="Excel" />;
        break;
      case 'exe':
        img = <img src={require('@src/assets/images/common/exe.png')} alt="程序" />;
        break;
      case 'flash':
        img = <img src={require('@src/assets/images/common/flash.png')} alt="Flash" />;
        break;
      case 'iso':
        img = <img src={require('@src/assets/images/common/iso.png')} alt="镜像文件" />;
        break;
      case 'pdf':
        img = <img src={require('@src/assets/images/common/pdf.png')} alt="PDF" />;
        break;
      case 'png':
      case 'gif':
      case 'jpg':
      case 'jpeg':
      case 'image':
        if (fileUrl) {
          img = <img src={fileUrl} alt="图片" />;
        } else {
          img = <img src={require('@src/assets/images/common/pic.png')} alt="图片" />;
        }
        break;
      case 'ppt':
      case 'pptx':
        img = <img src={require('@src/assets/images/common/ppt.png')} alt="PPT" />;
        break;
      case 'rar':
        img = <img src={require('@src/assets/images/common/rar.png')} alt="压缩文件" />;
        break;
      case 'txt':
        img = <img src={require('@src/assets/images/common/txt.png')} alt="文本" />;
        break;
      case 'html':
      case 'htm':
        img = <img src={require('@src/assets/images/common/web.png')} alt="网页" />;
        break;
      case 'doc':
      case 'docx':
        img = <img src={require('@src/assets/images/common/word.png')} alt="Word" />;
        break;
      case 'wps':
        img = <img src={require('@src/assets/images/common/wps.png')} alt="WPS" />;
        break;
      case 'zip':
      case '7z':
        img = <img src={require('@src/assets/images/common/zip.png')} alt="压缩文件" />;
        break;
      default:
        img = <img src={require('@src/assets/images/common/default.png')} alt="其他" />;
        break;
    }
    return img;
  },
  /**
   * 计算剩余时间是否过期
   * @param {number} time 秒
   */
  limitTime(time, type: number = 1) {
    if (!time) return '';
    const now: Date = new Date();
    const dealine: Date = new Date(time * 1000);
    const nowMoment = moment([now.getFullYear(), now.getMonth(), now.getDate()]);
    const dealineMoment = moment([dealine.getFullYear(), dealine.getMonth(), dealine.getDate()]);
    // console.log('sssss', nowMoment.format('YYYY-MM-DD'), dealineMoment.format('YYYY-MM-DD'), nowMoment.diff(dealineMoment, 'days'))
    if (nowMoment.isSame(dealineMoment)) {
      return '今日待办';
    }
    if (nowMoment.isAfter(dealineMoment)) {
      return `延期${nowMoment.diff(dealineMoment, 'days')}天`;
    }
    if (nowMoment.isBefore(dealineMoment)) {
      if (type !== 1) {
        return `${dealineMoment.format('MM月D日 星期dd')} 截止`;
      }
      return `剩余${dealineMoment.diff(nowMoment, 'days')}天`;
    }
    return '';
  },
  // 字符过滤器
  htmlFilter(text) {
    let regStr = '(' + Object.keys(matchList).toString() + ')';
    // ↑ ------------【*提取匹配列表key值*】.【组数转字符串】
    regStr = regStr.replace(/,/g, ')|(');
    // ↑ 通过匹配将其更新为正则的字符串类型
    const regExp = new RegExp(regStr, 'g');
    // ↑ ------- 字符串 转 正则 方法
    return text.replace(regExp, match => matchList[match]);
    // ↑ ------ 替换方法 (正则, 当前key => 返回当前被匹配的key值)
  },
  // 获取域名地址
  // getSitePreUrl: (() => {
  //   const config = {
  //     prod: {
  //       passport: 'https://passport.clouderwork.com',
  //       test: 'https://www.clouderwork.com',
  //       oc: 'https://oc.clouderwork.com',
  //       org: 'https://org.clouderwork.com',
  //       ent: 'https://e.clouderwork.com',
  //       app: 'https://app.clouderwork.com'
  //     },
  //     beta: {
  //       passport: 'https://beta-passport.yunwoke.com',
  //       test: 'https://beta.yunwoke.com',
  //       // oc: "",
  //       org: 'https://beta-org.yunwoke.com',
  //       ent: 'https://beta-ent.yunwoke.com',
  //       app: 'beta-app.yunwoke.com'
  //     },
  //     test: {
  //       passport: 'https://passport.yunwoke.com',
  //       test: 'https://test.yunwoke.com',
  //       oc: 'https://oc.yunwoke.com',
  //       org: 'https://org2.yunwoke.com',
  //       ent: 'https://ent.yunwoke.com',
  //       app: 'https://app.yunwoke.com'
  //     }
  //   };
  //   const origin = window.location.origin;
  //   const env = origin.includes('clouderwork') ? 'prod' : origin.includes('beta') ? 'beta' : 'test';
  //   return app => {
  //     return config[env][app] || config[env]['passport'];
  //   };
  // })(),

  /**
   * 千分位
   *
   * @param {number|string} num
   * @returns
   */
  getThousandths(num: number | string) {
    const parse = (val: number) => {
      const str = val.toString();

      if (str.includes('.')) {
        return val.toLocaleString();
      } else {
        return str.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }
    };

    if (typeof num === 'number') {
      return parse(num);
    } else if (typeof num === 'string') {
      const int = +num;

      if (typeof int === 'number') {
        return parse(int);
      }
    }
    return num;
  },

  // 分转元
  getYuan: val => {
    const num = String(val * 0.01);
    const reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
    return num.replace(reg, '$1,');
  }
};
